<template>
  <loading v-if="isLoading"></loading>
  <not-found v-else-if="!item"></not-found>
  <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
  <div v-else id="ehouse-calculating-detail" class="container-fluid">
    <div class="es-xs-12">
      <h4
        class="u-color-primary u-margin-top-small u-margin-bottom u-padding-right-xsmall u-padding-left-xsmall"
      >
        HEAT GAIN CALCULATION REPORT (E-House Single Room) ( {{ item.title }} )
      </h4>
    </div>
    <div class="es-xs-5">
      <h5 class="u-margin-bottom-xsmall">
        <strong>{{ $t("ehouseCalculating.wallsConstructionDetails") }}</strong>
      </h5>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.locationFactor") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestLocationFactor }} m
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.atmosphericPressure") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestAtmosphericPressure }} kPa
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.ambientTemperature") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestAmbientTemperature }} °C
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.ambientHumidity") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestAmbientHumidity }} %
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.radiationPower") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestRadiationPower }} W/m²
        </span>
      </div>
      <h5 class="u-margin-bottom-xsmall u-margin-top">
        <strong>{{ $t("ehouseCalculating.geometricParameters") }}</strong>
      </h5>

      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.length") }}: </span>
        <span class="u-amrgin-left-xsmall"> {{ item.requestLength }} mm </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.width") }}: </span>
        <span class="u-amrgin-left-xsmall"> {{ item.requestWidth }} mm </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.height") }}: </span>
        <span class="u-amrgin-left-xsmall"> {{ item.requestHeight }} mm </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.numberOfDoors") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestNumberOfDoors }} {{ $t("common.pcs") }}
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.electricalInletOutlet") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestElectricalInletOutlet }} mm
        </span>
      </div>
      <h5 class="u-margin-bottom-xsmall u-margin-top">
        <strong>{{ $t("ehouseCalculating.mainRoomAirConditions") }}</strong>
      </h5>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.airTemperature") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestAirTemperature }} °C
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.relativeHumidity") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestRelativeHumidity }} %
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.heatGeneration") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestHeatGeneration }} kW
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.requiredPressurization") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestRequiredPressurization }} Pa
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span>
          {{ $t("ehouseCalculating.requiredPressurizationStandard") }}:
        </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestRequiredPressurizationStandard }} Pa
        </span>
      </div>
      <h5 class="u-margin-bottom-xsmall u-margin-top">
        <strong>{{ $t("ehouseCalculating.wallsConstructionDetails") }}</strong>
      </h5>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span>
          {{ $t("ehouseCalculating.requiredPressurizationStandard") }}:
        </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestRequiredPressurizationStandard }} Pa
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span>
          {{ $t("ehouseCalculating.innerSideHeatConvectionCoefficient") }}:
        </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.requestRequiredPressurizationStandard }} Pa
        </span>
      </div>
    </div>
    <div class="es-xs-7">
      <img
        src="@/assets/images/ehouse-sema.png"
        width="100%"
        alt="ehouse sema"
      />
      <h5 class="u-margin-bottom-xsmall u-margin-top">
        <strong>{{ $t("ehouseCalculating.result") }}</strong>
      </h5>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span>
          {{ $t("ehouseCalculating.wallsCeilingFloorHeatTransfer") }}:
        </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseWallsCeilingFloorHeatTransfer }} W/m².K
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.heatTransmission") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseHeatTransmission }} kW
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.heatRadiation") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseHeatRadiation }} kW
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.heatDevices") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseHeatDevices }} kW
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.freshAirHeatGain") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseFreshAirHeatGain }} kW
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.airFlow") }}: </span>
        <span class="u-amrgin-left-xsmall"> {{ item.responseAirFlow }} </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.airFlowInfiltration") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseAirFlowInfiltration }}
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.condensateWater") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseCondensateWater }} m
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.heatCalculated") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseHeatCalculated }} m
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.totalHeatGain") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseTotalHeatGain }} kW
        </span>
      </div>
      <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.additionalHumidityRequired") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseAdditionalHumidityRequired }} %
        </span>
      </div>
      <!-- <div
        class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
      >
        <span> {{ $t("ehouseCalculating.safetyFactor") }}: </span>
        <span class="u-amrgin-left-xsmall">
          {{ item.responseSafetyFactor }} %
        </span>
      </div> -->
    </div>
  </div>
</template>

<script>
import Loading from "../../Base/Loading/Loading.vue";
import NotFound from "../../Base/NotFound.vue";
import html2pdf from "html2pdf.js";
import authorize from "./authorize";
export default {
  mixins: [authorize],
  components: {
    Loading,
    NotFound,
  },
  data() {
    return {
      cycleId: null,
      isLoading: true,
      cycle: null,
      creatingPdf: false,
      item: {},
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    result: {
      type: Object,
      required: true,
    },
    autoPrint: {
      type: Boolean,
      default: false,
    },
    autoExport: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setForm() {
      this.item = {
        title: this.title || this.$t("ehouseCalculating.mainTitle"),
        requestPvcThickness: this.form.pvcThickness,
        requestPvcThermalConductivity: this.form.pvcThermalConductivity,
        requestNoneMaterialThickness: this.form.noneMaterialThickness,
        requestNoneMaterialThermalConductivity:
          this.form.noneMaterialThermalConductivity,
        requestSteelPlateThickness: this.form.steelPlateThickness,
        requestSteelPlateThermalConductivity:
          this.form.steelPlateThermalConductivity,
        requestAsbestosThickness: this.form.asbestosThickness,
        requestAsbestosThermalConductivity:
          this.form.asbestosThermalConductivity,
        requestAirTemperature: this.form.airTemperature,
        requestRelativeHumidity: this.form.relativeHumidity,
        requestHeatGeneration: this.form.heatGeneration,
        requestRequiredPressurization: this.form.requiredPressurization,
        requestRequiredPressurizationStandard:
          this.form.requiredPressurizationStandard,
        requestLocationFactor: this.form.locationFactor,
        requestAtmosphericPressure: this.form.atmosphericPressure,
        requestAmbientTemperature: this.form.ambientTemperature,
        requestAmbientHumidity: this.form.ambientHumidity,
        requestRadiationPower: this.form.radiationPower,
        requestLength: this.form.length,
        requestWidth: this.form.width,
        requestHeight: this.form.height,
        requestNumberOfDoors: this.form.numberOfDoors,
        requestElectricalInletOutlet: this.form.electricalInletOutlet,
        responseWallsCeilingFloorHeatTransfer:
          this.result.wallsCeilingFloorHeatTransfer,
        responseHeatTransmission: this.result.heatTransmission,
        responseHeatRadiation: this.result.heatRadiation,
        responseHeatDevices: this.result.heatDevices,
        responseFreshAirHeatGain: this.result.freshAirHeatGain,
        responseAirFlowInfiltration: this.result.airFlowInfiltration,
        responseCondensateWater: this.result.condensateWater,
        responseHeatCalculated: this.result.heatCalculated,
        responseTotalHeatGain: this.result.totalHeatGain,
        responseAdditionalHumidityRequired:
          this.result.additionalHumidityRequired,
        responseSafetyFactor: this.result.safetyFactor,
        responseAirFlow: this.result.airFlow,
        createdDate: new Date().toISOString(),
      };
      this.isLoading = false;
      this.createPdf();
    },
    async getItem() {
      if (this.autoPrint) return this.setForm();
      this.isLoading = true;
      this.item = this.form;
      this.createPdf();
      this.isLoading = false;
    },
    async createPdfBlob() {
      const element = document.getElementById("ehouse-calculating-detail");
      const opt = {
        margin: [25, 1, 40, 1],
        filename: this.item.title + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      };

      const footerImg = "/pdf-footer.png";
      const headerImg = "/pdf-header.png";
      //const footerLogo = ;
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            // set footer to every page
            pdf.setPage(i);
            // set footer font
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.addImage(
              footerImg,
              "png",
              10,
              pdf.internal.pageSize.getHeight() - 30,
              pdf.internal.pageSize.getWidth() - 20,
              30
            );
            pdf.addImage(
              headerImg,
              "png",
              10,
              0,
              pdf.internal.pageSize.getWidth() - 20,
              25
            );
            // pdf.addImage(
            //   footerLogo,
            //   "png",
            //   0,
            //   0,
            //   pdf.internal.pageSize.getWidth(),
            //   0.3
            // );
          }
          window.open(pdf.output("bloburl"), "_blank");
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: false,
          });
          this.creatingPdf = false;
          this.$emit("pdfCreated");
        });
      return "";
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: "application/pdf" });
    },
    async createPdf() {
      this.creatingPdf = true;
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.creatingPdf"),
        duration: 20 * 60 * 1000,
      });
      setTimeout(async () => {
        await this.createPdfBlob();
      }, 500);
    },
  },
  mounted() {
    this.getItem();
  },
};
</script>

<style scoped>
page {
  background: white;
  display: block;
  margin: 0 auto;
  position: relative;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
}

.page_header {
  position: running(header);
  width: 100%;
}

.page_footer {
  position: running(footer);
  width: 100%;
}

.pdf-content {
  padding: 20px;
}
</style>
